<template>
    <div>
        <v-layout row wrap align-center justify-space-between>
            <v-flex class="handbook-leftDivider_hideSmall">
                <v-btn-toggle v-model="inputVal" class="transparent handbook_toggleButton" :mandatory="true" :multiple="true">
                    <v-tooltip v-for="(map, index) in maps" :key="map.$Id" top disabled>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button electorate_button" :value="map.Id"><span class="long-button-text chamberButton">{{ map.DateFrom }}–{{ map.DateTo || 'present' }}</span><v-chip disabled :pill="true" :small="true" :color="allColours[index]">&nbsp;</v-chip>
                            <v-icon aria-hidden="true" v-if="mapLoading && currentMap == map.Id" class="loading">cached</v-icon>
                            </v-btn>
                        </template>
                    </v-tooltip>
                </v-btn-toggle>
            </v-flex>
        </v-layout>
        <br/>
        <electorate-map v-if="currentMap.length > 0" :id="currentMap" :colours="colours" :electorate="electorate" @setLoading="setLoading"></electorate-map>
    </div>
</template>
<script>
import axios from 'axios';
import ElectorateMap from './ElectorateMap.vue'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    components: {
        ElectorateMap
    },
    props: ['electorate', 'state'],
    data() {
        return {
            showMaps: true,
            loading: true,
            mapLoading: false,
            maps: [],
            currentMap: [],
            value: [],
            baseColours: [
                '#003b49',
                '#1b365d',
                '#5d3754',
                '#007a78',
                '#000000',
                '#e56db1',
                '#00bfb2',
                '#be84a3',
                '#d3273e',
                '#1d4289',
                '#dc582a',
                '#41b6e6',
                '#94a596',
                '#ffc845'
            ]
        }
    },
    mounted() {
        this.loadMaps();
    },
    computed: {
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val);
                this.currentMap = val;
            }
        },
        allColours() {
            // check to see index of currentmap, and select a colour based on that
            const mappedColours = this.maps.map(c => this.baseColours[this.maps.findIndex(m => m.Id === c.Id) % (this.baseColours.length)]);
            return mappedColours;

        },
        colours() {
            // check to see index of currentmap, and select a colour based on that
            const mappedColours = this.currentMap.map(c => this.baseColours[this.maps.findIndex(m => m.Id === c) % (this.baseColours.length)]);
            return mappedColours;
        }
    },
    methods: {
        setLoading: function (status) {
            this.mapLoading = status;
        },
        loadMaps: function () {
            const url = `ElectorateMaps/ElectorateMaps?electorate=${this.electorate}&state=${this.state}`;
            axios.get(`api/${url}`)
                .then(response => {
                    const data = response.data;
                    if (response.data == null) {
                        this.showMaps = false;
                        this.loading = false;
                        return;
                    }
                    this.maps = data
                    if (this.maps.length > 0) {
                        this.currentMap = [this.maps[this.maps.length - 1].Id];
                        this.value = this.currentMap;
                    }
                    this.loading = false;
                });
        }
    }
}
</script>
<style scoped>
.handbook_toggleButton {
    flex-wrap: wrap;
}
.electorate_button {
    max-width: 160px;
}
</style>